export enum EButtonVariant {
    DEFAULT = 'default',
    SECONDARY = 'secondary',
    DESTRUCTIVE = 'destructive',
    OUTLINE = 'outline',
    GHOST = 'ghost',
    LINK = 'link',
}

export enum EButtonSize {
    SM = 'sm',
    DEFAULT = 'default',
    LG = 'lg',
}